// Import model
import { Surface } from '../models/Surface';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { Point } from '../models/Point';

// Import dependency serializers (for complex types)
import { PointSerializer } from './PointSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Surface - handles JSON serialization and deserialization with type validation
 */
export class SurfaceSerializer {
  /**
   * Deserializes a JSON string into a Surface instance
   */
  static deserialize(json: string): Surface {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Surface instance
   */
  static fromObject(obj: any): Surface {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Surface');
    }


    const instance: Surface = {
      area: obj['area'] as number | undefined,
      name: obj['name'] as string | undefined,
      perimeter: obj['perimeter'] as number | undefined,
      shape: obj['shape'] ? (obj['shape'] as any[]).map((item: any) =>
        PointSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Surface instances
   */
  static deserializeArray(json: string): Surface[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Surface instance to a JSON string
   */
  static serialize(instance: Surface): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Surface instance to a plain object
   */
  static toObject(instance: Surface): any {
    return {
      'area': instance.area,
      'name': instance.name,
      'perimeter': instance.perimeter,
      'shape': instance.shape?.map((item: any) =>
        PointSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of Surface instances to a JSON string
   */
  static serializeArray(instances: Surface[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
